module.exports = __webpack_public_path__ + "img/Bygghemma.414d61e3.png";